import { DataProtectionResponse } from "@/pages/security/DataProtectionResponse.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { DataProtectionResponsePage } from "@/types/data-protection.types.ts";

export const dataProtectionRoutes: RouteConfig[] = [
  {
    path: "/data-protection/accept/:uuid/:object_id",
    element: <DataProtectionResponse page={DataProtectionResponsePage.accept} />,
  },
  {
    path: "/data-protection/decline/:uuid/:object_id",
    element: <DataProtectionResponse page={DataProtectionResponsePage.decline} />,
  },
  {
    path: "/data-protection/delete-request/:uuid/:object_id",
    element: <DataProtectionResponse page={DataProtectionResponsePage.deleteRequest} />,
  },
  {
    path: "/data-protection/edit-request/:uuid/:object_id",
    element: <DataProtectionResponse page={DataProtectionResponsePage.editRequest} />,
  },
];
